import { formatCurrency } from 'utils/CurrencyUtils';

import makeClasses from './ToppingInfo.style';

import type { LiHTMLAttributes, ReactNode } from 'react';
import type { ToppingToPrint } from 'features/print-management/order-invoice-printing';

export function ToppingInfo(props: Props) {
  const { topping, localeLang, previousName, children, ...liProps } = props;
  const hideName = topping.name === previousName;
  const _classes = makeClasses({ hideName });
  return (
    <li
      data-topping-id={`${topping.id}`}
      className={_classes.liTopping}
      {...liProps}
    >
      <p aria-label='topping-name'>{topping.name}:</p>
      <div className={_classes.toppingInfo}>
        <p lang={localeLang}>
          {topping.units > 1 && `${topping.units}x `}
          {topping.description}
        </p>
        <p>{formatCurrency(topping.price.real)}</p>
      </div>
      {children}
    </li>
  );
}

interface Props extends LiHTMLAttributes<HTMLLIElement> {
  topping: ToppingToPrint;
  localeLang: string;
  previousName: ToppingToPrint['name'];
  children: ReactNode;
}
